import jsPDF from "jspdf";
import "jspdf-autotable";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Bank Statement Analysis Report", 40, yPos);
    yPos += 40;

    // Customer Identification & Account Profile
    doc.setFontSize(14);
    doc.text("Customer Identification & Account Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Name: ${data.customerProfile?.name || data.customerDetails?.name || data.name || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.customerProfile?.panCard || data.customerDetails?.pan || data.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Aadhar: ${data.customerProfile?.aadharCard || data.customerDetails?.aadhar || data.aadhar || 'N/A'}`, 40, yPos);
    doc.text(`Account Number: ${data.customerProfile?.accountNumber || data.accountDetails?.accountNumber || data.accountNumber || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Bank Name: ${data.customerProfile?.bankName || data.accountDetails?.bankName || data.bankName || 'N/A'}`, 40, yPos);
    doc.text(`IFSC: ${data.customerProfile?.ifsc || data.accountDetails?.ifsc || data.ifsc || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Statement Period: ${data.customerProfile?.statementPeriod || data.statementDetails?.period || data.statementPeriod || 'N/A'}`, 40, yPos);
    doc.text(`Account Type: ${data.customerProfile?.accountType || data.accountDetails?.accountType || data.accountType || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Statement Summary
    doc.setFontSize(14);
    doc.text("Statement Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Opening Balance: Rs ${data.statementSummary?.openingBalance || data.balances?.opening || '0'}`, 40, yPos);
    doc.text(`Closing Balance: Rs ${data.statementSummary?.closingBalance || data.balances?.closing || '0'}`, 300, yPos);
    yPos += 15;
    doc.text(`Minimum Balance: Rs ${data.statementSummary?.minimumBalance || data.balances?.minimum || '0'}`, 40, yPos);
    doc.text(`Maximum Balance: Rs ${data.statementSummary?.maximumBalance || data.balances?.maximum || '0'}`, 300, yPos);
    yPos += 15;
    doc.text(`Total Credits: Rs ${data.statementSummary?.totalCredits || data.transactions?.totalCredits || '0'}`, 40, yPos);
    doc.text(`Total Debits: Rs ${data.statementSummary?.totalDebits || data.transactions?.totalDebits || '0'}`, 300, yPos);
    yPos += 15;
    doc.text(`Monthly Avg Credit: Rs ${data.statementSummary?.monthlyAvgCredit || data.averages?.monthlyCredit || '0'}`, 40, yPos);
    doc.text(`Monthly Avg Debit: Rs ${data.statementSummary?.monthlyAvgDebit || data.averages?.monthlyDebit || '0'}`, 300, yPos);
    yPos += 15;
    doc.text(`Average Monthly Balance: Rs ${data.statementSummary?.averageMonthlyBalance || data.averages?.monthlyBalance || '0'}`, 40, yPos);
    yPos += 30;

    // Income & Deposit Analysis
    doc.setFontSize(14);
    doc.text("Income & Deposit Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Salary/Business Income: Rs ${data.incomeDepositAnalysis?.salaryBusinessIncome || 'N/A'}`, 40, yPos);
    doc.text(`Transfer from Others: Rs ${data.incomeDepositAnalysis?.transferFromOthers || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Cash Deposits: Rs ${data.incomeDepositAnalysis?.cashDeposits || 'N/A'}`, 40, yPos);
    doc.text(`Other Deposits: Rs ${data.incomeDepositAnalysis?.otherDeposits || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Spending & Outflow Analysis
    doc.setFontSize(14);
    doc.text("Spending & Outflow Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`EMI/Loans: Rs ${data.spendingOutflowAnalysis?.emiLoans?.amount || 'N/A'}`, 40, yPos);
    doc.text(`UPI/Wallets: Rs ${data.spendingOutflowAnalysis?.upiWallets?.amount || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Credit Card Payments: Rs ${data.spendingOutflowAnalysis?.creditCardPayments?.amount || 'N/A'}`, 40, yPos);
    doc.text(`Cash Withdrawals: Rs ${data.spendingOutflowAnalysis?.cashWithdrawals || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Utilities: Rs ${data.spendingOutflowAnalysis?.utilities?.amount || 'N/A'}`, 40, yPos);
    doc.text(`Misc Transfers: Rs ${data.spendingOutflowAnalysis?.miscTransfers || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Rent/Lease: Rs ${data.spendingOutflowAnalysis?.rentLease?.amount || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Banking Ratios Summary
    doc.setFontSize(14);
    doc.text("Banking Ratios Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Avg Monthly Inflow: Rs ${data.bankingRatios?.avgMonthlyInflow || 'N/A'}`, 40, yPos);
    doc.text(`Avg Monthly Outflow: Rs ${data.bankingRatios?.avgMonthlyOutflow || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Balance Stability Index: ${data.bankingRatios?.balanceStabilityIndex || 'N/A'}%`, 40, yPos);
    doc.text(`EMI-to-Income Ratio: ${data.bankingRatios?.emiToIncomeRatio || 'N/A'}%`, 300, yPos);
    yPos += 15;
    doc.text(`Cash Deposit Ratio: ${data.bankingRatios?.cashDepositRatio || 'N/A'}%`, 40, yPos);
    doc.text(`Debit-to-Credit Ratio: ${data.bankingRatios?.debitToCreditRatio || 'N/A'}%`, 300, yPos);
    yPos += 30;

    // Final Credit Analyst Verdict
    doc.setFontSize(14);
    doc.text("Final Credit Analyst Verdict", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Eligibility Assessment: ${data.finalVerdict?.eligibilityAssessment || 'N/A'}`, 40, yPos);
    doc.text(`Cash Flow Trend: ${data.finalVerdict?.cashFlowTrend || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Net Banking Position: ${data.finalVerdict?.netBankingPosition || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Key Strengths & Areas for Improvement
    doc.setFontSize(14);
    doc.text("Key Strengths", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const strengths = data.keyStrengths || ['No key strengths identified'];
    strengths.forEach(strength => {
      doc.text(`• ${strength}`, 40, yPos);
      yPos += 15;
    });
    yPos += 15;

    doc.setFontSize(14);
    doc.text("Areas for Improvement", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const improvements = data.areasForImprovement || ['No areas for improvement identified'];
    improvements.forEach(improvement => {
      doc.text(`• ${improvement}`, 40, yPos);
      yPos += 15;
    });

    doc.save("bank-statement-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const BankStatementAnalysisReport = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  // Helper function to safely get nested values
  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-6 text-sm space-y-6 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Bank Statement Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Customer Profile */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🧾 Customer Identification & Account Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Name</strong>
            <span className="text-white">
              {getValue("customerProfile.name") ||
                getValue("customerDetails.name") ||
                getValue("name")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN Card</strong>
            <span className="text-white">
              {getValue("customerProfile.panCard") ||
                getValue("customerDetails.pan") ||
                getValue("pan")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Aadhar Card</strong>
            <span className="text-white">
              {getValue("customerProfile.aadharCard") ||
                getValue("customerDetails.aadhar") ||
                getValue("aadhar")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Account Number</strong>
            <span className="text-white">
              {getValue("customerProfile.accountNumber") ||
                getValue("accountDetails.accountNumber") ||
                getValue("accountNumber")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Bank Name</strong>
            <span className="text-white">
              {getValue("customerProfile.bankName") ||
                getValue("accountDetails.bankName") ||
                getValue("bankName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">IFSC</strong>
            <span className="text-white">
              {getValue("customerProfile.ifsc") ||
                getValue("accountDetails.ifsc") ||
                getValue("ifsc")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Statement Period</strong>
            <span className="text-white">
              {getValue("customerProfile.statementPeriod") ||
                getValue("statementDetails.period") ||
                getValue("statementPeriod")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Account Type</strong>
            <span className="text-white">
              {getValue("customerProfile.accountType") ||
                getValue("accountDetails.accountType") ||
                getValue("accountType")}
            </span>
          </div>
        </div>
      </div>

      {/* Statement Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💳 Statement Summary
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Opening Balance</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.openingBalance") ||
                getValue("balances.opening") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Minimum Balance</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.minimumBalance") ||
                getValue("balances.minimum") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Total Credits</strong>
            <span className="text-green-400">
              ₹
              {(
                getValue("statementSummary.totalCredits") ||
                getValue("transactions.totalCredits") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Total Debits</strong>
            <span className="text-red-400">
              ₹
              {(
                getValue("statementSummary.totalDebits") ||
                getValue("transactions.totalDebits") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Closing Balance</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.closingBalance") ||
                getValue("balances.closing") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Maximum Balance</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.maximumBalance") ||
                getValue("balances.maximum") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Monthly Avg Credit</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.monthlyAvgCredit") ||
                getValue("averages.monthlyCredit") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Monthly Avg Debit</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.monthlyAvgDebit") ||
                getValue("averages.monthlyDebit") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Average Monthly Balance</strong>
            <span className="text-white">
              ₹
              {(
                getValue("statementSummary.averageMonthlyBalance") ||
                getValue("averages.monthlyBalance") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      </div>

      {/* Income & Deposit Analysis */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📈 Income & Deposit Analysis
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Salary / Business Income</strong>
            <span className="text-white">
              ₹
              {data.incomeDepositAnalysis?.salaryBusinessIncome?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Transfer from Others</strong>
            <span className="text-white">
              ₹
              {data.incomeDepositAnalysis?.transferFromOthers?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Cash Deposits</strong>
            <span className="text-white">
              ₹
              {data.incomeDepositAnalysis?.cashDeposits?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Other Deposits</strong>
            <span className="text-white">
              ₹
              {data.incomeDepositAnalysis?.otherDeposits?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Spending & Outflow */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📉 Spending & Outflow Analysis
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">EMI / Loans</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.emiLoans?.amount?.toLocaleString("en-IN") ||
                "N/A"}{" "}
              {data.spendingOutflowAnalysis?.emiLoans?.details
                ? `(${data.spendingOutflowAnalysis.emiLoans.details})`
                : ""}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">UPI / Wallets</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.upiWallets?.amount?.toLocaleString("en-IN") ||
                "N/A"}{" "}
              {data.spendingOutflowAnalysis?.upiWallets?.details
                ? `(${data.spendingOutflowAnalysis.upiWallets.details})`
                : ""}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">Credit Card Payments</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.creditCardPayments?.amount?.toLocaleString("en-IN") ||
                "N/A"}{" "}
              {data.spendingOutflowAnalysis?.creditCardPayments?.details
                ? `(${data.spendingOutflowAnalysis.creditCardPayments.details})`
                : ""}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">Cash Withdrawals</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.cashWithdrawals?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">Utilities</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.utilities?.amount?.toLocaleString("en-IN") ||
                "N/A"}{" "}
              {data.spendingOutflowAnalysis?.utilities?.details
                ? `(${data.spendingOutflowAnalysis.utilities.details})`
                : ""}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">Misc Transfers</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.miscTransfers?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:justify-between">
            <strong className="text-[#AAAAAA]">Rent / Lease</strong>
            <span className="text-white">
              ₹
              {data.spendingOutflowAnalysis?.rentLease?.amount?.toLocaleString("en-IN") ||
                "N/A"}{" "}
              {data.spendingOutflowAnalysis?.rentLease?.details
                ? `(${data.spendingOutflowAnalysis.rentLease.details})`
                : ""}
            </span>
          </div>
        </div>
      </div>

      {/* Key Transaction Behaviour */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🧠 Key Transaction Behaviour
        </h2>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left text-sm min-w-[500px]">
            <thead className="text-gray-400">
              <tr>
                <th>Parameters</th>
                <th>Value</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.transactionBehavior?.map((behavior, index) => (
                <tr key={index}>
                  <td>{behavior.parameter}</td>
                  <td>{behavior.value}</td>
                  <td
                    className={
                      behavior.status === "Good"
                        ? "text-green-400"
                        : behavior.status === "Warning"
                        ? "text-yellow-400"
                        : "text-red-400"
                    }
                  >
                    {behavior.status}
                  </td>
                </tr>
              )) || (
                <tr>
                  <td colSpan="3" className="text-center text-gray-400">
                    No transaction behavior data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Cash Flow Chart */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💸 Cash Flow Consistency Chart
        </h2>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left mt-3 text-sm min-w-[500px]">
            <thead className="text-gray-400">
              <tr>
                <th>Month</th>
                <th>Credit</th>
                <th>Debit</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.cashFlowChart?.map((month, index) => (
                <tr key={index}>
                  <td>{month.month}</td>
                  <td className="text-green-400">
                    ₹{month.credit?.toLocaleString("en-IN")}
                  </td>
                  <td className="text-red-400">
                    ₹{month.debit?.toLocaleString("en-IN")}
                  </td>
                  <td
                    className={
                      month.status === "Positive"
                        ? "text-green-400"
                        : "text-red-400"
                    }
                  >
                    {month.status}
                  </td>
                </tr>
              )) || (
                <tr>
                  <td colSpan="4" className="text-center text-gray-400">
                    No cash flow data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Banking Ratios */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🏦 Banking Ratios Summary
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              Avg Monthly Inflow
            </strong>
            <span className="text-white text-lg font-medium">
              ₹{data.bankingRatios?.avgMonthlyInflow?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              Avg Monthly Outflow
            </strong>
            <span className="text-white text-lg font-medium">
              ₹
              {data.bankingRatios?.avgMonthlyOutflow?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              Balance Stability Index
            </strong>
            <span className="text-white text-lg font-medium">
              {data.bankingRatios?.balanceStabilityIndex || "N/A"}%
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              EMI-to-Income Ratio
            </strong>
            <span className="text-white text-lg font-medium">
              {data.bankingRatios?.emiToIncomeRatio || "N/A"}%
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              Cash Deposit Ratio
            </strong>
            <span className="text-white text-lg font-medium">
              {data.bankingRatios?.cashDepositRatio || "N/A"}%
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA] text-sm">
              Debit-to-Credit Ratio
            </strong>
            <span className="text-white text-lg font-medium">
              {data.bankingRatios?.debitToCreditRatio || "N/A"}%
            </span>
          </div>
        </div>
      </div>

      {/* Final Verdict */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center space-y-2">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📌 Final Credit Analyst Verdict
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Eligibility Assessment</strong>
            <span className="text-green-400">
              {data.finalVerdict?.eligibilityAssessment || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Cash Flow Trend</strong>
            <span className="text-green-400">
              {data.finalVerdict?.cashFlowTrend || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Net Banking Position</strong>
            <span className="text-green-400">
              {data.finalVerdict?.netBankingPosition || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Key Strengths / Areas for Improvement */}
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
          <h3 className="font-semibold text-green-500 mb-2">
            ✅ Key Strengths
          </h3>
          <ul className="list-disc pl-5 space-y-1">
            {data.keyStrengths?.map((strength, index) => (
              <li key={index}>{strength}</li>
            )) || <li>No key strengths identified</li>}
          </ul>
        </div>
        <div className="bg-yellow-950 border border-yellow-600 rounded-lg p-4 text-yellow-300">
          <h3 className="font-semibold text-yellow-400 mb-2">
            ⚠️ Areas for Improvement
          </h3>
          <ul className="list-disc pl-5 space-y-1">
            {data.areasForImprovement?.map((area, index) => (
              <li key={index}>{area}</li>
            )) || <li>No areas for improvement identified</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BankStatementAnalysisReport;
